// extracted by mini-css-extract-plugin
export default {"version-link":"rollout-history_version-link__GrUBO"};